var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFacebookQuick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "18px",
    viewBox: "0 0 9 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5FDEF8A9-45C1-4727-9DA4-36E89132EBAF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CoreFit-Landing-Page-Option3",
    transform: "translate(-1395.000000, -742.000000)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.571428571
  }, /*#__PURE__*/React.createElement("g", {
    id: "banner"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quick-right-button",
    transform: "translate(1320.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.6515888,16.5150405 C80.6730398,15.6793625 80.5289454,14.5153111 80.7714343,14.1179642 C81.2149091,13.3902446 82.9855439,13.5796716 82.9855439,13.5796716 L82.9855439,11.004664 C80.1917927,11.004664 79.27733,10.8797121 78.3190327,11.9233099 C77.4661248,12.8514523 77.4395443,14.6747497 77.3691293,16.5150405 L76,16.5150405 L76,19.0320705 L77.384518,19.0320705 C77.3840517,21.657059 77.3854507,24.5339503 77.384518,27 L80.6385317,27 L80.6385317,19.0010825 L82.513157,19.0010825 C82.6591166,18.1549085 82.8013457,17.4926637 83,16.5150405 L80.6515888,16.5150405",
    id: "ic_facebook-quick"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebookQuick);
export default __webpack_public_path__ + "static/media/ic_facebook-quick.d8d9d0d12c4191d23727dcc9896cd751.svg";
export { ForwardRef as ReactComponent };